<app-application-steps-generic [configuration]="configuration" [disabled]="disabled"></app-application-steps-generic>
